<template>
    <div class="cards item" @click="toChooseCard">
        <div v-if="hasSelectedCards">
            <span>
                <small>-</small><decimal-price :mystyle="{color:'black!important'}" :price="selectedCards.deductionInfo.deductionValue" decimalSize="10px" :unit="true" :forcePoint="true"/>
            </span>
            <icon class="arrow">quanju_liebiaojiantou</icon>
        </div>
        <div v-else >
            <span>
                  {{matchCardNum}}张券可用
            </span>
            <icon class="arrow">quanju_liebiaojiantou</icon>
        </div>
        <div class="card-label">
            <div  style="margin-left:7px;">{{cardName}}</div>
            <img src="../../../../image/user/card.png" width="20px" style="margin-right: 15px; vertical-align: text-top;" alt="">
        </div>
    </div>
</template>
<script>
    import { mapState, mapActions } from 'vuex'
    import icon from '../../../components/icon'
    import decimalPrice from '../../../components/decimal-price.vue'
    import op from 'object-path'
    import theme from '../../../theme'

    export default {
        props: ['thirdOrderId'],
        data() {
            return {
              cardName: theme.get('CARD_NAME')
            }
        },
        methods: {
            toChooseCard() {
                this.$router.push({
                    name: 'preorderCards',
                })
            },
        },
        computed: {
            hasSelectedCards() {
                if(op(this.selectedCards).get('epayList.length') > 0) {
                    return true
                }else {
                    return false
                }
            },
            ...mapState({
                selectedCards: state => state.preorder.selectedCards,
                matchCardNum: state => state.preorder.orderMatchCardNum,//定单可用的卡数量
            })
        },
        components: {
            icon,decimalPrice
        },
    }
</script>
